import React from 'react';
import useBreakpoint from 'use-breakpoint';
import Footer from './Footer';
import Header from './Header';
import Panel from './Panel';
import Square from './Square';
import BlockAcquaintance from './BlockAcquaintance';
import BlockArrows from './BlockArrows';
import BlockSlider from './BlockSlider';
import BlockUnpack from './BlockUnpack';
import BlockBottom from './BlockBottom';
import BlockFours from './BlockFours';
import BlockTitle from './BlockTitle';
import BlockModa from './BlockModa';
import { isMobile, MQ } from './Media';

import panda338Img from './img/friday-panda_338.jpg';
import panda339Img from './img/friday-panda_339.jpg';

import './App.scss';
import BlockFours2 from './BlockFours2';
import BlockMap from './BlockMap';
import BlockAddress from './BlockAddress';


function App() {
    const { minWidth } = useBreakpoint(MQ, 'sm');

    return (
        <div className="container-xxl app-wrapper">
            <Header />
            <Panel color="blue-light">
                <BlockTitle />
            </Panel>
            {isMobile(minWidth) ? <Panel color="blue">
                <BlockArrows />
            </Panel> : null}
            <BlockAcquaintance />
            {!isMobile(minWidth) ? <Panel color="blue">
                <BlockArrows />
            </Panel> : null}
            <Panel color="blue-light">
                <BlockSlider />
            </Panel>
            <BlockModa />
            <BlockFours />
            {false && <Panel color="blue">
                <BlockUnpack />
            </Panel>}
            <Panel>
                <BlockAddress />
            </Panel>
            <Panel>
                <BlockMap />
            </Panel>
            {false && <Panel color="blue">
                <BlockBottom />
            </Panel>}
            {false && <BlockFours />}
            
            {false && <Panel color="red">
                <div>
                    <img className="w-100" src={isMobile(minWidth) ? panda339Img : panda338Img} alt="" />
                </div>
            </Panel>}
            {false && <BlockFours2 />}
            <Footer />
        </div>
    );
}

export default App;
